const amountDueInputs = [
  ...document.querySelectorAll<HTMLInputElement>(
    '[name="bamboraAmountDue"], [amount-due], [name="member_renewal_category"]'
  ),
];

const quantityInputs = [
  ...document.querySelectorAll<HTMLInputElement>("[amount-per-unit]"),
];

const amountDueTotal = document.querySelector<HTMLElement>(
  ".js-bambora-amount-due"
);

const emailInput = document.querySelector<HTMLInputElement>(
  '.js-field-input[type="email"]'
);

const feeApplies = (code: string) => {
  switch (code) {
    case "PAPER_FEE":
      if (!emailInput) throw new Error("No email input found.");
      return emailInput.offsetParent === null;
    default:
      return true;
  }
};

const getAppliedFees = () =>
  (window.FEES ?? []).filter((fee) => {
    const { code } = fee;
    if (!code) throw new Error("Empty fee code.");
    const applies = feeApplies(code);
    return applies;
  });

const getAppliedFeesTotal = () =>
  getAppliedFees().map((fee) => Number(fee.amount));

const tickAmountDue = () => {
  const includeField = (input: HTMLInputElement) =>
    input.type === "radio" || input.type === "checkbox" ? input.checked : true;

  const amountDueLineItems = amountDueInputs
    .filter(includeField)
    .filter((input) => !!Number(input.dataset.amount || input.value))
    .map((input) => Number(input.dataset.amount || input.value));

  const quantityLineItems = quantityInputs
    .filter(includeField)
    .filter((input) => !!Number(input.value))
    .map(
      (input) =>
        Number(input.value) * Number(input.getAttribute("amount-per-unit"))
    );

  const amountDue = [
    ...amountDueLineItems,
    ...quantityLineItems,
    ...getAppliedFeesTotal(),
  ].reduce((value, carry) => value + carry, 0);

  if (amountDueTotal) {
    amountDueTotal.innerText = new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
    }).format(amountDue);
  }
};

if (
  (amountDueInputs.length > 0 || quantityInputs.length > 0) &&
  amountDueTotal
) {
  tickAmountDue();
  [...amountDueInputs, ...quantityInputs].forEach((input) =>
    input.addEventListener("change", tickAmountDue)
  );
  if (emailInput) {
    setInterval(tickAmountDue, 250);
  }
}
